package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.platform.LocalUriHandler

@Composable
actual fun rememberFeedbackSender(): (FeedbackEmail) -> Unit {
    val uriHandler = LocalUriHandler.current
    return { email ->
        try {
            val body = "${email.templateBody}\n\n==============\n\n${email.debugInfo}"
            val subject = encodeUriComponent(email.subject)
            val encodedBody = encodeUriComponent(body)
            uriHandler.openUri("mailto:$FEEDBACK_EMAIL_ADDRESS?subject=$subject&body=$encodedBody")
        } catch (e: Exception) {
            println("Failed to open mail client: ${e.message}")
        }
    }
}
